export class LockedUsersController {
    constructor($scope, $location, $rootScope, UserService, LockService) {
        $scope.vm = this;
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.location = $location;
        this.UserService = UserService;
        this.LockService = LockService;
        this.init();
    }

    init() {
        this.scope.isLoadedPage = this.rootScope.content.location === this.location.path();
        this.scope.adsLimit = 5;
        this.scope.loading = false;

        if(this.rootScope.content.location !== this.location.path()) {
            this.rootScope.content.items = [];
            this.rootScope.content.page = 1;
            this.rootScope.content.pageCount = 0;
            this.rootScope.content.limit = 18;
            this.rootScope.content.maxItem = 0;
            this.rootScope.content.location = this.location.path();

            this.UserService.getCurrentUser()
                .then((response) => { let user = response.data;
                    this.rootScope.currentUserProfile = user.data;
                })
                .catch((response) => { let err = response.data;
                    console.error(err);
                });

            this.loadMore();
        }
    }

    canLoadMore() {
        return this.rootScope.content.pageCount >= this.rootScope.content.page;
    }

    loadMore() {
        if(this.scope.loading) return;
        this.scope.loading = true;
        this.LockService.getLockedUsers(this.rootScope.content.page, this.rootScope.content.limit)
            .then((_res) => { let response = _res.data;
                this.rootScope.content.maxItem = response.itemCount;
                this.rootScope.content.pageCount = response.pageCount;
                if(!this.rootScope.isVip()) {
                    let period = 9;
                    let countAds = Math.floor(response.data.length / period);
                    //insert ads after period
                    for(let i = 0; i < countAds; i++) {
                        if(this.scope.adsLimit > 0 && (i != 0 || this.rootScope.content.page != 1)) {
                            response.data.splice(i * period, 0, {_id: Date.now() + i, banner: true});
                            this.scope.adsLimit--;
                        }
                    }
                }
                this.rootScope.content.items = this.rootScope.content.items.concat(response.data);
                this.rootScope.content.items = _.uniqBy(this.rootScope.content.items, item => item._id);
                this.rootScope.content.page++;
                this.scope.isLoadedPage = true;
                this.scope.loading = false;
            })
            .catch((response) => { let err = response.data;
                this.scope.isLoadedPage = true;
                this.scope.loading = false;
                console.error(err);
            });
    }

    unblockContact(user, index) {
        this.LockService.unlockUser(user)
            .then((response) => {
                this.rootScope.content.items.splice(index, 1);
            })
            .catch((response) => { let error = response.data;
                console.log(error);
            });
    }
}
